import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useCallback, useEffect, useState } from "react";

dayjs.extend(duration);

export const useTimer = ({ pausedAt, finishedAt, onFinished, state }) => {
	const [timeLeft, setTimeLeft] = useState(null);
	const [hasFinished, setHasFinished] = useState(false);

	const calculateTimeLeft = useCallback(
		(nowDate = new Date()) => {
			const now = dayjs(nowDate);
			const end = dayjs(finishedAt);

			if (end.isBefore(now)) {
				setHasFinished(true);
				setTimeLeft(null);
				return;
			}

			const diffDuration = dayjs.duration(end.diff(now));
			const formattedTime = diffDuration.format("HH:mm:ss");

			setTimeLeft(formattedTime);
		},
		[finishedAt],
	);

	useEffect(() => {
		if (hasFinished && onFinished) {
			onFinished();
		}
	}, [hasFinished, onFinished]);

	useEffect(() => {
		if (!hasFinished) {
			calculateTimeLeft(pausedAt ?? new Date());
			if (!hasFinished && state !== "paused") {
				const timer = setInterval(() => {
					calculateTimeLeft();
				}, 1000);

				return () => clearInterval(timer);
			}
		}
	}, [state, pausedAt, hasFinished, calculateTimeLeft]);

	if (timeLeft === null) {
		const diffDuration = dayjs.duration(0);
		return diffDuration.format("HH:mm:ss");
	}

	return timeLeft;
};
